import React, { useState } from "react"

import SummarizeAttendanceButton from "@/components/Skynet/AttendanceSummary/SummarizeAttendanceButton"
import AttendanceSummaryUpsellDialog from "@/components/Skynet/AttendanceSummary/Upsell/AttendanceSummaryUpsellDialog"

import { UserInInstanceRoleName } from "@/protocols/userInInstance"

const CHIP_TEXT_FOR_USER_WITHOUT_IA = "Saiba como resumir com IA"
const CHIP_TEXT_WHEN_SUMMARY_INCLUDED = "Resumo incluso ✓"
const CHIP_TEXT_WHEN_SUMMARY_NOT_INCLUDED = "Resumir com IA"

type GenerateAttendanceSummaryButtonProps = {
	hasAIResourcesPermission: boolean
	userRoleName: UserInInstanceRoleName
	onToggle: (includeSummary: boolean) => void
}

const GenerateAttendanceSummaryButton: React.FC<GenerateAttendanceSummaryButtonProps> = (props) => {
	const {
		hasAIResourcesPermission,
		userRoleName,
		onToggle
	} = props

	const [isSummaryIncluded, setIsSummaryIncluded] = useState<boolean>(false)

	const handleToggleSummaryInclusion = () => {
		const nextIsSummaryIncluded = !isSummaryIncluded
		setIsSummaryIncluded(nextIsSummaryIncluded)
		onToggle(nextIsSummaryIncluded)
	}

	const handleSummaryChipClick = () => {
		if (hasAIResourcesPermission) {
			handleToggleSummaryInclusion()
		} else {
			AttendanceSummaryUpsellDialog.open({
				userRoleName,
				source: "inbox"
			})
		}
	}

	const summaryChipLabel = !hasAIResourcesPermission
		? CHIP_TEXT_FOR_USER_WITHOUT_IA
		: isSummaryIncluded
			? CHIP_TEXT_WHEN_SUMMARY_INCLUDED
			: CHIP_TEXT_WHEN_SUMMARY_NOT_INCLUDED

	return (
		<SummarizeAttendanceButton
			label={summaryChipLabel}
			isActive={isSummaryIncluded}
			onClick={handleSummaryChipClick}
		/>
	)
}

export default GenerateAttendanceSummaryButton
